import { SETTING_COUPON_ADD, SETTING_COUPON_ADD_FAIL, SETTING_COUPON_ADD_SUCCESS, SETTING_COUPON_DELETE, SETTING_COUPON_DELETE_FAIL, SETTING_COUPON_DELETE_SUCCESS, SETTING_COUPON_EDIT, SETTING_COUPON_EDIT_FAIL, SETTING_COUPON_EDIT_SUCCESS, SETTING_COUPON_LIST, SETTING_COUPON_LIST_FAIL, SETTING_COUPON_LIST_SUCCESS, SETTING_DECLARATIONS_ADD, SETTING_DECLARATIONS_ADD_FAIL, SETTING_DECLARATIONS_ADD_SUCCESS, SETTING_DECLARATIONS_DELETE, SETTING_DECLARATIONS_DELETE_FAIL, SETTING_DECLARATIONS_DELETE_SUCCESS, SETTING_DECLARATIONS_EDIT, SETTING_DECLARATIONS_EDIT_FAIL, SETTING_DECLARATIONS_EDIT_SUCCESS, SETTING_DECLARATIONS_LIST, SETTING_DECLARATIONS_LIST_FAIL, SETTING_DECLARATIONS_LIST_SUCCESS, SETTING_LOCKER_ADD, SETTING_LOCKER_ADD_FAIL, SETTING_LOCKER_ADD_SUCCESS, SETTING_LOCKER_DELETE, SETTING_LOCKER_DELETE_FAIL, SETTING_LOCKER_DELETE_SUCCESS, SETTING_LOCKER_EDIT, SETTING_LOCKER_EDIT_FAIL, SETTING_LOCKER_EDIT_SUCCESS, SETTING_LOCKER_LIST, SETTING_LOCKER_LIST_FAIL, SETTING_LOCKER_LIST_SUCCESS, SETTING_NOTIFICATION_ADD, SETTING_NOTIFICATION_ADD_FAIL, SETTING_NOTIFICATION_ADD_SUCCESS, SETTING_NOTIFICATION_DELETE, SETTING_NOTIFICATION_DELETE_FAIL, SETTING_NOTIFICATION_DELETE_SUCCESS, SETTING_NOTIFICATION_EDIT, SETTING_NOTIFICATION_EDIT_FAIL, SETTING_NOTIFICATION_EDIT_SUCCESS, SETTING_NOTIFICATION_LIST, SETTING_NOTIFICATION_LIST_FAIL, SETTING_NOTIFICATION_LIST_SUCCESS, SHIPPING_PARTNER_ADD, SHIPPING_PARTNER_ADD_FAIL, SHIPPING_PARTNER_ADD_SUCCESS, SHIPPING_PARTNER_DELETE, SHIPPING_PARTNER_DELETE_FAIL, SHIPPING_PARTNER_DELETE_SUCCESS, SHIPPING_PARTNER_EDIT, SHIPPING_PARTNER_EDIT_FAIL, SHIPPING_PARTNER_EDIT_SUCCESS, SHIPPING_PARTNER_LIST, SHIPPING_PARTNER_LIST_FAIL, SHIPPING_PARTNER_LIST_SUCCESS, SHOPPER_PRICE_ADD, SHOPPER_PRICE_ADD_FAIL, SHOPPER_PRICE_ADD_SUCCESS, SHOPPER_PRICE_DELETE, SHOPPER_PRICE_DELETE_FAIL, SHOPPER_PRICE_DELETE_SUCCESS, SHOPPER_PRICE_EDIT, SHOPPER_PRICE_EDIT_FAIL, SHOPPER_PRICE_EDIT_SUCCESS, SHOPPER_PRICE_LIST, SHOPPER_PRICE_LIST_FAIL, SHOPPER_PRICE_LIST_SUCCESS, SINGEL_SETTING_LOCKER_LIST, SINGEL_SETTING_LOCKER_LIST_FAIL, SINGEL_SETTING_LOCKER_LIST_SUCCESS} from "../../actions/admin/customer-actions";
import { call, put, takeLatest, } from "redux-saga/effects";
import { API } from "../../api";

function* shippingParterCreate(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.shippingParterCreate, action.payload);
        yield put({ type: SHIPPING_PARTNER_ADD_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SHIPPING_PARTNER_ADD_FAIL, payload: { error: error } });
    }
}

function* shippingParterDelete(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.shippingParterDelete, action.payload);
        yield put({ type: SHIPPING_PARTNER_DELETE_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SHIPPING_PARTNER_DELETE_FAIL, payload: { error: error } });
    }
}

function* shippingParterEdit(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.shippingParterEdit, action.payload);
        yield put({ type: SHIPPING_PARTNER_EDIT_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SHIPPING_PARTNER_EDIT_FAIL, payload: { error: error } });
    }
}

function* shippingParterList(action) {
    try {
        const response = yield call(API.shippingParterList, action.payload);
        yield put({ type: SHIPPING_PARTNER_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: SHIPPING_PARTNER_LIST_FAIL, payload: { error: error } });
    }
}

function* settingCouponCreate(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.settingCouponCreate, action.payload);
        yield put({ type: SETTING_COUPON_ADD_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SETTING_COUPON_ADD_FAIL, payload: { error: error } });
    }
}

function* settingCouponDelete(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.settingCouponDelete, action.payload);
        yield put({ type: SETTING_COUPON_DELETE_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SETTING_COUPON_DELETE_FAIL, payload: { error: error } });
    }
}

function* settingCouponEdit(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.settingCouponEdit, action.payload);
        yield put({ type: SETTING_COUPON_EDIT_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SETTING_COUPON_EDIT_FAIL, payload: { error: error } });
    }
}

function* settingCouponList(action) {
    try {
        const response = yield call(API.settingCouponList, action.payload);
        yield put({ type: SETTING_COUPON_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: SETTING_COUPON_LIST_FAIL, payload: { error: error } });
    }
}
function* settingDeclarationsCreate(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.settingDeclarationCreate, action.payload);
        yield put({ type: SETTING_DECLARATIONS_ADD_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SETTING_DECLARATIONS_ADD_FAIL, payload: { error: error } });
    }
}

function* settingDeclarationsDelete(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.settingDeclarationDelete, action.payload);
        yield put({ type: SETTING_DECLARATIONS_DELETE_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SETTING_DECLARATIONS_DELETE_FAIL, payload: { error: error } });
    }
}

function* settingDeclarationsEdit(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.settingDeclarationEdit, action.payload);
        yield put({ type: SETTING_DECLARATIONS_EDIT_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SETTING_DECLARATIONS_EDIT_FAIL, payload: { error: error } });
    }
}

function* settingDeclarationsList(action) {
    try {
        const response = yield call(API.settingDeclarationList, action.payload);
        yield put({ type: SETTING_DECLARATIONS_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: SETTING_DECLARATIONS_LIST_FAIL, payload: { error: error } });
    }
}
function* settingNotificationCreate(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.settingNotificationCreate, action.payload);
        yield put({ type: SETTING_NOTIFICATION_ADD_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SETTING_NOTIFICATION_ADD_FAIL, payload: { error: error } });
    }
}

function* settingNotificationDelete(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.settingNotificationDelete, action.payload);
        yield put({ type: SETTING_NOTIFICATION_DELETE_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SETTING_NOTIFICATION_DELETE_FAIL, payload: { error: error } });
    }
}

function* settingNotificationEdit(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.settingNotificationEdit, action.payload);
        yield put({ type: SETTING_NOTIFICATION_EDIT_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SETTING_NOTIFICATION_EDIT_FAIL, payload: { error: error } });
    }
}

function* settingNotificationList(action) {
    try {
        const response = yield call(API.settingNotificationList, action.payload);
        yield put({ type: SETTING_NOTIFICATION_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: SETTING_NOTIFICATION_LIST_FAIL, payload: { error: error } });
    }
}


// locker items start
function* lockerItemsCreate(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.lockerItemsCreate, action.payload);
        yield put({ type: SETTING_LOCKER_ADD_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SETTING_LOCKER_ADD_FAIL, payload: { error: error } });
    }
}

function* lockerItemsDelete(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.lockerItemsDelete, action.payload);
        yield put({ type: SETTING_LOCKER_DELETE_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SETTING_LOCKER_DELETE_FAIL, payload: { error: error } });
    }
}

function* lockerItemsEdit(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.lockerItemsUpdate, action.payload);
        yield put({ type: SETTING_LOCKER_EDIT_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SETTING_LOCKER_EDIT_FAIL, payload: { error: error } });
    }
}

function* lockerItemsList(action) {
    try {
        const response = yield call(API.lockerItemsList, action.payload);
        yield put({ type: SETTING_LOCKER_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: SETTING_LOCKER_LIST_FAIL, payload: { error: error } });
    }
}

function* singleLockerItemsList(action) {
    try {
        const response = yield call(API.singlelockerItemsList, action.payload);
        yield put({ type: SINGEL_SETTING_LOCKER_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: SINGEL_SETTING_LOCKER_LIST_FAIL, payload: { error: error } });
    }
}


// shopper-pricing start
function* shopperPriceCreate(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.ShopperPricingCreate, action.payload);
        yield put({ type: SHOPPER_PRICE_ADD_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SHOPPER_PRICE_ADD_FAIL, payload: { error: error } });
    }
}

function* shopperPriceDelete(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.ShopperPricingDelete, action.payload);
        yield put({ type: SHOPPER_PRICE_DELETE_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SHOPPER_PRICE_DELETE_FAIL, payload: { error: error } });
    }
}

function* shopperPriceEdit(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.ShopperPricingUpdate, action.payload);
        yield put({ type: SHOPPER_PRICE_EDIT_SUCCESS, payload: response.data });
        if (typeof onSuccess === "function") {
           onSuccess();
        }
    } catch (error) {
        yield put({ type: SHOPPER_PRICE_EDIT_FAIL, payload: { error: error } });
    }
}

function* shopperPriceList(action) {
    try {
        const response = yield call(API.shopperPricingList, action.payload);
        yield put({ type: SHOPPER_PRICE_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: SHOPPER_PRICE_LIST_FAIL, payload: { error: error } });
    }
}

function* singleShopperPriceList(action) {
    try {
        const response = yield call(API.singleShopperPricingList, action.payload);
        yield put({ type: SINGEL_SETTING_LOCKER_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: SINGEL_SETTING_LOCKER_LIST_SUCCESS, payload: { error: error } });
    }
}
function* settingDataSaga() {
    yield takeLatest(SHIPPING_PARTNER_ADD, shippingParterCreate);
    yield takeLatest(SHIPPING_PARTNER_EDIT, shippingParterEdit);
    yield takeLatest(SHIPPING_PARTNER_DELETE, shippingParterDelete);
    yield takeLatest(SHIPPING_PARTNER_LIST, shippingParterList);

    yield takeLatest(SETTING_COUPON_ADD, settingCouponCreate);
    yield takeLatest(SETTING_COUPON_EDIT, settingCouponEdit);
    yield takeLatest(SETTING_COUPON_DELETE, settingCouponDelete);
    yield takeLatest(SETTING_COUPON_LIST, settingCouponList);
    
    yield takeLatest(SETTING_DECLARATIONS_ADD, settingDeclarationsCreate);
    yield takeLatest(SETTING_DECLARATIONS_EDIT, settingDeclarationsEdit);
    yield takeLatest(SETTING_DECLARATIONS_DELETE, settingDeclarationsDelete);
    yield takeLatest(SETTING_DECLARATIONS_LIST, settingDeclarationsList);
    
    yield takeLatest(SETTING_NOTIFICATION_ADD, settingNotificationCreate);
    yield takeLatest(SETTING_NOTIFICATION_EDIT, settingNotificationEdit);
    yield takeLatest(SETTING_NOTIFICATION_DELETE, settingNotificationDelete);
    yield takeLatest(SETTING_NOTIFICATION_LIST, settingNotificationList);

    yield takeLatest(SETTING_LOCKER_ADD, lockerItemsCreate);
    yield takeLatest(SETTING_LOCKER_DELETE, lockerItemsDelete);
    yield takeLatest(SETTING_LOCKER_EDIT, lockerItemsEdit);
    yield takeLatest(SETTING_LOCKER_LIST, lockerItemsList);
    yield takeLatest(SINGEL_SETTING_LOCKER_LIST, singleLockerItemsList);

    yield takeLatest(SHOPPER_PRICE_ADD, shopperPriceCreate);
    yield takeLatest(SHOPPER_PRICE_DELETE, shopperPriceDelete);
    yield takeLatest(SHOPPER_PRICE_EDIT, shopperPriceEdit);
    yield takeLatest(SHOPPER_PRICE_LIST, shopperPriceList);
    yield takeLatest(SINGEL_SETTING_LOCKER_LIST, singleShopperPriceList);
}

export default settingDataSaga;



